import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface SlideCampaignExampleProps {
  onContinue: () => void;
}
export function SlideCampaignExample({
  onContinue
}: SlideCampaignExampleProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 200);
    const t2 = setTimeout(() => setStage(2), 700);
    return () => {
      ;
      [t1, t2].forEach(clearTimeout);
    };
  }, []);
  return <div className="h-full w-full bg-white flex flex-col px-8 py-7 md:px-16 md:py-8 max-w-[1400px] mx-auto overflow-y-auto" data-id="element-230" data-mp="1uhw3ga5bak7f">
      {/* Heading */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: stage >= 1 ? 1 : 0,
      y: stage >= 1 ? 0 : 20
    }} transition={{
      duration: 0.5
    }} className="mb-6" data-id="element-231" data-mp="1loapuu4vv8zl">
        <p className="text-[#6C2BD9] text-xs md:text-sm font-bold uppercase tracking-[0.2em]" data-id="element-232" data-mp="2i55f84x5pwuz">
          Example of campaign insights
        </p>
        <h2 className="text-3xl md:text-5xl font-sans font-bold text-slate-900 tracking-tight leading-tight mt-2" data-id="element-233" data-mp="2wkqemnhhgxtv">
          Roche <span className="text-[#6C2BD9]" data-id="element-234" data-mp="2rj173htgz2aj">Columvi</span> · Survival data
          Snak · Q2 Germany
        </h2>
        <p className="text-slate-600 text-base md:text-lg mt-2 max-w-3xl" data-id="element-235" data-mp="31ja42xvacrqz">
          An example campaign — delivered through HCP channels, measured
          end-to-end, and feeding directly into the next planned Snak.
        </p>
      </motion.div>

      {/* Three artifacts */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: stage >= 2 ? 1 : 0,
      y: stage >= 2 ? 0 : 20
    }} transition={{
      duration: 0.5
    }} className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-236" data-mp="3bb61s7tgmfuo">
        {/* 1 — Delivery */}
        <div className="flex flex-col" data-id="element-237" data-mp="1pws7ghlxrerv">
          <div className="flex items-center gap-2 mb-2" data-id="element-238" data-mp="1pxv12xan7vbh">
            <span className="w-6 h-6 rounded-full bg-[#6C2BD9] text-truewhite text-xs font-bold flex items-center justify-center flex-shrink-0" data-id="element-239" data-mp="3pz1im8klxnce">
              1
            </span>
            <p className="text-xs uppercase tracking-[0.15em] text-slate-700 font-bold" data-id="element-240" data-mp="2ssfqbm4ixvl">
              Delivered across HCP channels
            </p>
          </div>
          <div className="flex-1 rounded-2xl border border-slate-200 bg-slate-50 overflow-hidden flex items-center justify-center p-2" data-id="element-241" data-mp="7q0ojlldtpk6">
            <img src="https://cdn.magicpatterns.com/uploads/mRQ9xtrVTry9KFG87o5QRR/Screenshot_2026-06-02_at_09.32.43.png" alt="Snak delivered via WhatsApp plus additional channels: embed, SMS, QR, social, email, ads, congress" className="w-full h-full object-contain" data-id="element-242" data-mp="hprjfoduu6ks" />
          </div>
          <p className="text-xs text-slate-500 mt-2 leading-relaxed" data-id="element-243" data-mp="vjsm2t7xgdqf">
            WhatsApp, email, SMS, QR, embed, social, ads, congress — same Snak,
            many channels.
          </p>
        </div>

        {/* 2 — Measured */}
        <div className="flex flex-col" data-id="element-244" data-mp="15lwb0jxo8a51">
          <div className="flex items-center gap-2 mb-2" data-id="element-245" data-mp="15kuva25pmzgz">
            <span className="w-6 h-6 rounded-full bg-[#6C2BD9] text-truewhite text-xs font-bold flex items-center justify-center flex-shrink-0" data-id="element-246" data-mp="10mth9vn55qcd">
              2
            </span>
            <p className="text-xs uppercase tracking-[0.15em] text-slate-700 font-bold" data-id="element-247" data-mp="wnax52359jal">
              Measured end-to-end
            </p>
          </div>
          <div className="flex-1 rounded-2xl border border-slate-200 bg-slate-50 overflow-hidden flex items-center justify-center p-2" data-id="element-248" data-mp="1odfa4fokr41s">
            <img src="https://cdn.magicpatterns.com/uploads/23PQF13gRfzS74bbVADvhP/Screenshot_2026-06-02_at_09.58.57.png" alt="Snakker analytics dashboard — Snak Engagers 395, CTR 52%, Engagement Rate 68%, plus Cue-level funnel" className="w-full h-full object-contain" data-id="element-249" data-mp="1jjkubnc3b97z" />
          </div>
          <p className="text-xs text-slate-500 mt-2 leading-relaxed" data-id="element-250" data-mp="1rspah3hf1q16">
            563 sessions · 52% CTR · 68% engagement · 5,014 clicks · full Cue
            funnel.
          </p>
        </div>

        {/* 3 — Next campaigns */}
        <div className="flex flex-col" data-id="element-251" data-mp="1itvftinnb9q9">
          <div className="flex items-center gap-2 mb-2" data-id="element-252" data-mp="1iuwtzvzykcc7">
            <span className="w-6 h-6 rounded-full bg-[#6C2BD9] text-truewhite text-xs font-bold flex items-center justify-center flex-shrink-0" data-id="element-253" data-mp="1mux8fgn24nj9">
              3
            </span>
            <p className="text-xs uppercase tracking-[0.15em] text-slate-700 font-bold" data-id="element-254" data-mp="2fj2ss2a78aik">
              Feeds the next campaigns
            </p>
          </div>
          <div className="flex-1 rounded-2xl border border-slate-200 bg-slate-50 overflow-hidden flex items-center justify-center p-2" data-id="element-255" data-mp="21plil83eka57">
            <img src="https://cdn.magicpatterns.com/uploads/ugrgJKPRmQ4KaV1mXrRktb/Screenshot_2026-06-02_at_09.36.13.png" alt="Next planned campaigns roadmap — MoA, Survival, Disease control, Depth of response, Guidelines" className="w-full h-full object-contain" data-id="element-256" data-mp="2tic6mvaxmsjd" />
          </div>
          <p className="text-xs text-slate-500 mt-2 leading-relaxed" data-id="element-257" data-mp="huyxzvxfdqlv">
            Behavioural signals shape the next 5 Snaks — MoA, Survival, Disease
            control, Depth of response, Guidelines.
          </p>
        </div>
      </motion.div>

      {/* Tagline */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: stage >= 2 ? 1 : 0,
      y: stage >= 2 ? 0 : 10
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="mt-5 rounded-2xl bg-[#6C2BD9] px-5 py-3.5 flex flex-wrap items-center gap-x-4 gap-y-1" data-id="element-258" data-mp="3wis277e044s">
        <p className="text-[10px] uppercase tracking-[0.25em] text-truewhite/80 font-bold" data-id="element-259" data-mp="1p8aq4txh0c4o">
          The closed loop
        </p>
        <p className="text-sm md:text-base font-bold text-truewhite leading-snug" data-id="element-260" data-mp="1k8xxttntycup">
          Deliver · Measure · Learn · Sharpen the next campaign — every quarter,
          per country.
        </p>
      </motion.div>
    </div>;
}